import { useI18n, type Lang } from "../i18n";

const LANGS: { code: Lang; label: string }[] = [
  { code: "th", label: "ไทย" },
  { code: "en", label: "EN" },
  { code: "ko", label: "한국어" },
];

export function LangToggle({ className = "" }: { className?: string }) {
  const { lang, setLang } = useI18n();
  return (
    <div className={`inline-flex overflow-hidden rounded-full bg-white p-0.5 text-sm font-bold ring-1 ring-black/10 ${className}`}>
      {LANGS.map((l) => (
        <button
          key={l.code}
          onClick={() => setLang(l.code)}
          className={`rounded-full px-2.5 py-1 transition ${
            lang === l.code ? "bg-[var(--theme-main)] text-white" : "text-ink/55 hover:text-ink"
          }`}
          aria-pressed={lang === l.code}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
